<a [FCRouterLink]="route" id="fc-all-details" [innerHtml]="compareButtonText"></a>